// extracted by mini-css-extract-plugin
export default {"progressContainer":"ProgressBar_progressContainer__-dTwG","progressBar":"ProgressBar_progressBar__C8eRI"};